import React, { useEffect, useState } from 'react';
import { RefreshCw, X } from 'lucide-react';

/**
 * "New version available" prompt — shown when the API gateway reports a newer deployed release than the bundle
 * this tab is running (apiClient dispatches `wt:update-available` on version drift). A plain reload picks up the
 * new build (index.html is served no-cache). Non-intrusive + dismissable so we never yank the page mid-action.
 */
const UpdateAvailableBanner: React.FC = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onUpdate = () => setShow(true);
    window.addEventListener('wt:update-available', onUpdate as EventListener);
    return () => window.removeEventListener('wt:update-available', onUpdate as EventListener);
  }, []);

  if (!show) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[100] flex items-center gap-3 rounded-xl border border-secondary-200 dark:border-secondary-700 bg-white dark:bg-secondary-900 px-4 py-2.5 shadow-lg">
      <RefreshCw className="w-4 h-4 text-secondary-500" />
      <span className="text-sm text-secondary-800 dark:text-secondary-100">A new version of Wisetree is available.</span>
      <button
        onClick={() => window.location.reload()}
        className="rounded-lg bg-secondary-900 dark:bg-white px-3 py-1 text-xs font-semibold text-white dark:text-secondary-900 hover:opacity-90"
      >
        Refresh
      </button>
      <button onClick={() => setShow(false)} className="text-secondary-400 hover:text-secondary-700 dark:hover:text-secondary-200" aria-label="Dismiss">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default UpdateAvailableBanner;
